export default __webpack_public_path__ + "img/whatNews3.7ea1767a.jpg";